import { searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionTypes from './type';

export const handleupdateinvoiceid = (invoicedId) => async(dispatch) => {
        
    await dispatch({
        type: actionTypes?.RECEIVED_CURRENT_INVOICE_ID,
        payload: invoicedId
    })
}

export const requestGetAllInvoices = (queryparams) => async(dispatch) => {
    dispatch(requestShowLoader())
        
    try{
    await dispatch({
        type: actionTypes?.REQUEST_GET_ALL_INVOICE,
    })
    const invoiceSearchUrl = `${process.env.REACT_APP_BASE_URL}invoice`;
    const response = await searchRequestData(queryparams , invoiceSearchUrl , false)
    await dispatch({
        type : actionTypes?.RECEIVED_ALL_INVOICE,
        isLoading : false,
        payload : response?.data
    })
}
catch(error){
await dispatch({
        type : actionTypes?.RECEIVED_ERROR,
        error : error,
    })
}
dispatch(requestHideLoader())
}
